
import moment from 'moment';
//import { useStoreState } from 'easy-peasy';

export const dateFormat = (date) => {
  const moment = require('moment');
  let dateFirst = moment(date).format('MM-DD-YYYY');
  let dateSecond = moment(date, 'MM-DD-YYYY').format('MM-DD-YYYY');

  if (dateFirst.toLowerCase() !== 'invalid date') {
      return dateFirst;
  } else if (dateSecond.toLowerCase() !== 'invalid date') {
      return dateSecond
  } else {
      return '';
  }
}

// Replace date format with correct format for all browser
export const replaceDateFormat = (date) => date.replace(/[-_]/g, '/');

export const camelize = (str) => {
  return str
    .trim()
    .toLowerCase()
    .split(' ')
    .map(function(word) {
      return word[0].toUpperCase() + word.substr(1);
    })
    .join(' ');
}

export const getFileNameExtension = (fileName=null) => {
  var re = /(?:\.([^.]+))?$/;

  return re.exec(fileName)[1];
}

/**
 * @description
 * To sort arraylist according to key
 */
/* export const sortDataList = (data, name, isAscending) => {
  if (isAscending) {
    return data.sort((a, b) =>
      a[name]?.toLowerCase() > b[name]?.toLowerCase()
        ? 1
        : b[name]?.toLowerCase() > a[name]?.toLowerCase()
        ? -1
        : 0,
    );
  }
  return data.sort((a, b) =>
    a[name]?.toLowerCase() < b[name]?.toLowerCase() ? 1 : b[name]?.toLowerCase() < a[name]?.toLowerCase() ? -1 : 0,
  );
}; */

export const filterDataList = (list, key, value, isEqual = false) => {
  return list.filter(function (item) {
    if (!isEqual) {
      return item && item[key] !== value;
    }
  });
};

export const selectedOBJ = (list, key, value) => {
  return list.filter((item) => {
    return item && item[key] === value;
  });
};

export const displayDate = (date, format) => {
  return moment(date).format(format);
};

export const capitalize = (str) => {
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}